import { useContext, useEffect } from 'react'

import { MODALS_ID, QUERY_KEY } from '../../../constants'

import { ModalContext } from '../../../provider/ModalProvider'

import { queryClient } from '../../../utils/queryClient'

import { Button } from '../../../components/button'
import { Modal } from '../../../components/modal'
import { Text } from '../../../components/text'

export function SuccessVerificationModal() {
  const { closeModal } = useContext(ModalContext)

  const close = () => closeModal(MODALS_ID.ALERT)

  useEffect(() => {
    queryClient.invalidateQueries({ queryKey: [QUERY_KEY.userInfo] })
  }, [])

  return (
    <Modal id={MODALS_ID.ALERT}>
      <Text size={16} weight={500} block={true} $textAlign="center">
        휴대폰 번호가 등록되었어요.
      </Text>
      <Modal.Footer>
        <Button type="primary" href="/personalInfo" onClick={close}>
          확인
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
